import React, { useEffect, useMemo, useState } from "react";
import { saveAs } from "file-saver";
import HtmlDocx from "html-docx-js/dist/html-docx";
import Payments from "./payments";
import { FaFileWord } from "react-icons/fa";
import ReportPage from "./ipsas/parts";
import axios from "axios";
import { rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import Randcs from "./ipsas/randcs1";
import { FaSpinner } from "react-icons/fa";
import Bcomp2 from "./ipsas/bcomp2";
import Policies from "./ipsas/policies";
import Notesfs from "./ipsas/notesfs";
import Lgcf from "./ipsas/lgcf";
import Cdf from "./ipsas/cdf";
import Cashbooks from "./ipsas/cashbooks";

const Ipsas = ({startDate, endDate}) => {
  const auth = useAuth();
  const [ipsasData, setIpsasData] = useState({});
  const [loading, setLoading] = useState(false);
  const [previousYearOpeningBalance, setPreviousYearOpeningBalance] = useState(null);

  const fetchData = async () => {
    try {
      if (!auth?.user?.cid) return;
      setLoading(true);
      const url = startDate && endDate 
        ? rootUrl(`/ipsas/${auth.user.cid}~${startDate}~${endDate}`)
        : rootUrl(`/ipsas/${auth.user.cid}`);
      const response = await axios.get(url);
      const payload = response.data;
      if (Array.isArray(payload)) {
        setIpsasData(payload);
        setPreviousYearOpeningBalance(null);
      } else {
        setIpsasData(payload?.rows || []);
        setPreviousYearOpeningBalance(
          payload?.previousYearOpeningBalance !== null && payload?.previousYearOpeningBalance !== undefined
            ? parseFloat(payload.previousYearOpeningBalance) || 0
            : null
        );
      }
    
    } catch (error) {
      console.error("Error fetching IPSAS data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.user?.cid, startDate, endDate]);

  const { currentYearData, previousYearData } = useMemo(() => {
    const dataArray = Array.isArray(ipsasData) ? ipsasData : [];
    // Use startDate to determine the year, fallback to current date if not provided
    const dateToUse = startDate ? new Date(startDate) : new Date();
    const currentYear = dateToUse.getFullYear();
    const prevYear = currentYear - 1;

    const isRowInYear = (row, year) => {
      const d = row?.date ? new Date(row.date) : null;
      return d && !isNaN(d) && d.getFullYear() === year;
    };
   
    return {
      currentYearData: dataArray.filter(row => isRowInYear(row, currentYear)),
      previousYearData: dataArray.filter(row => isRowInYear(row, prevYear)),
 
    };
  }, [ipsasData, startDate]);
  const exportToWord = async () => {
    try {
      // Get HTML content from the DOM
      const content = document.querySelector(".toBeExported").innerHTML;
      // Convert HTML content to a .docx file using html-docx-js
      const converted = HtmlDocx.asBlob(content);
      saveAs(converted, "exported-content.docx");
    } catch (error) {
      console.error("Error exporting to Word:", error);
    }
  };


  return (
    <div>
        <button
        className="px-4 py-2 m-4 bg-blue-950 text-white rounded-md"
         onClick={exportToWord}> <FaFileWord/> </button>
      <div className="toBeExported">
        {loading ? (
          <div className="flex justify-center items-center h-48 w-full text-blue-950">
            <FaSpinner size={40} className="animate-spin" />
          </div>
        ) : (
          <>
            <ReportPage ipsasData={ipsasData} currentYearData={currentYearData} previousYearData={previousYearData} startDate={startDate} />
            <Randcs currentYearData={currentYearData} previousYearData={previousYearData} sof={0} startDate={startDate} previousYearOpeningBalance={previousYearOpeningBalance} />
            <Bcomp2 currentYearData={currentYearData} startDate={startDate} />
            <Randcs currentYearData={currentYearData.filter(a=>a.sof==2)} previousYearData={previousYearData.filter(a=>a.sof==2)} sof={2} startDate={startDate} previousYearOpeningBalance={previousYearOpeningBalance} />
            <Randcs currentYearData={currentYearData.filter(a=>a.sof==3)} previousYearData={previousYearData.filter(a=>a.sof==3)} sof={3} startDate={startDate} previousYearOpeningBalance={previousYearOpeningBalance} />
            <Randcs currentYearData={currentYearData.filter(a=>a.sof==7)} previousYearData={previousYearData.filter(a=>a.sof==7)} sof={7} startDate={startDate} previousYearOpeningBalance={previousYearOpeningBalance} />
            <Policies />
            <Notesfs currentYearData={currentYearData} previousYearData={previousYearData} startDate={startDate} />
            <Lgcf currentYearData={currentYearData.filter(a=>a.sof==2)} previousYearData={previousYearData.filter(a=>a.sof==2)} sof={2} startDate={startDate} />
            <Lgcf currentYearData={currentYearData.filter(a=>a.sof==3)} previousYearData={previousYearData.filter(a=>a.sof==3)} sof={3} startDate={startDate} />
            <Lgcf currentYearData={currentYearData.filter(a=>a.sof==7)} previousYearData={previousYearData.filter(a=>a.sof==7)} sof={7} startDate={startDate} />
              <Cashbooks currentYearData={currentYearData} previousYearData={previousYearData} startDate={startDate} />
          </>
        )}
      </div>
      
    </div>
  );
};

export default Ipsas;
